/**
 * @file XeroStatusWidget.js
 * @version 1.1.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-02-02
 * @modified 2026-10-03
 *
 * The signed-in user's Xero connection. With the system's own connection
 * (XERO_AUTH_MODE=custom) there is nothing for a person to connect or
 * disconnect: Dashboard passes no handlers, and this says whose connection it
 * is instead of offering buttons that would do nothing.
 */

import React from 'react';

function XeroStatusWidget({ xeroConnected, checkingXero, onReconnect, onDisconnect }) {
  const systemConnection = !onReconnect && !onDisconnect;
  return (
    <div className="dashboard-card xero-card">
      <div className="card-header">
        <h3>
          <span className="material-symbols-rounded">link</span>
          Xero
        </h3>
      </div>
      <div className="card-body">
        <div className="connection-status-container">
          {checkingXero ? (
            <div className="connection-status checking">
              <span className="material-symbols-rounded spinning">progress_activity</span>
              <span>Checking...</span>
            </div>
          ) : xeroConnected ? (
            <div className="connection-status connected">
              <div className="connected-info">
                <span className="material-symbols-rounded">check_circle</span>
                <strong>{systemConnection ? 'Connected (system connection)' : 'Connected'}</strong>
              </div>
              {onDisconnect && (
                <button onClick={onDisconnect} className="btn-disconnect">
                  <span className="material-symbols-rounded">link_off</span>
                  Disconnect
                </button>
              )}
            </div>
          ) : (
            <div className="connection-status disconnected">
              <span className="material-symbols-rounded">cancel</span>
              {onReconnect ? (
                <button onClick={onReconnect} className="btn-reconnect">
                  Reconnect
                </button>
              ) : (
                <span>The system connection needs attention — please tell an administrator.</span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default XeroStatusWidget;
